// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.product-inputs-container .product-table-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 0.375rem 0.375rem 0 0;
  padding: 1rem 1.5rem;
}
.product-inputs-container .product-table-header h5 {
  font-weight: 600;
  font-size: 1.1rem;
  letter-spacing: 0.5px;
}
.product-inputs-container .product-table-header .table-controls .btn {
  transition: all 0.2s ease;
  border-width: 2px;
  font-weight: 500;
}
.product-inputs-container .product-table-header .table-controls .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.product-inputs-container .product-table-header .table-controls .btn.btn-outline-success {
  border-color: rgba(255, 255, 255, 0.6);
  color: white;
}
.product-inputs-container .product-table-header .table-controls .btn.btn-outline-success:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: white;
}
.product-inputs-container .product-table-header .table-controls .btn.btn-outline-danger {
  border-color: rgba(255, 255, 255, 0.6);
  color: white;
}
.product-inputs-container .product-table-header .table-controls .btn.btn-outline-danger:hover {
  background-color: rgba(220, 53, 69, 0.8);
  border-color: #dc3545;
}
.product-inputs-container .form-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}
.product-inputs-container .form-label::after {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.5rem;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-bottom: 3px solid #667eea;
  transition: all 0.2s ease;
}
.product-inputs-container .form-control,
.product-inputs-container .form-select {
  border: 2px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}
.product-inputs-container .form-control:focus,
.product-inputs-container .form-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  transform: translateY(-1px);
}
.product-inputs-container .form-control::placeholder,
.product-inputs-container .form-select::placeholder {
  color: #adb5bd;
  font-style: italic;
}
.product-inputs-container .form-control.is-invalid,
.product-inputs-container .form-select.is-invalid {
  border-color: #dc3545;
}
.product-inputs-container .form-control.is-invalid:focus,
.product-inputs-container .form-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}
.product-inputs-container .form-control[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}
.product-inputs-container .form-control[type=number]::-webkit-outer-spin-button, .product-inputs-container .form-control[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.product-inputs-container .btn {
  border-radius: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.product-inputs-container .btn.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}
.product-inputs-container .btn.btn-primary:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
}
.product-inputs-container .btn.btn-primary:disabled {
  background: #adb5bd;
  transform: none;
  box-shadow: none;
}
.product-inputs-container .btn.btn-secondary.btn-outline {
  border: 2px solid #6c757d;
  color: #6c757d;
}
.product-inputs-container .btn.btn-secondary.btn-outline:hover {
  background-color: #6c757d;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(108, 117, 125, 0.2);
}
.product-inputs-container .alert {
  border-radius: 0.5rem;
  border: none;
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;
}
.product-inputs-container .alert.alert-success {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  border-left: 4px solid #28a745;
}
.product-inputs-container .alert.alert-danger {
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
  border-left: 4px solid #dc3545;
}
.product-inputs-container .invalid-feedback {
  display: block !important;
  font-size: 0.75rem;
  color: #dc3545;
  margin-top: 0.25rem;
  font-weight: 500;
}
.product-inputs-container .invalid-feedback::before {
  content: "⚠ ";
  margin-right: 0.25rem;
}
.product-inputs-container .card {
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.product-inputs-container .card .card-header {
  border-bottom: none;
}
.product-inputs-container .card .card-header.product-table-header {
  margin: 0;
  border-radius: 0;
}
.product-inputs-container .card .card-body.p-0 {
  padding: 0 !important;
}
@media (max-width: 768px) {
  .product-inputs-container .table-controls {
    flex-direction: column;
    gap: 0.5rem;
  }
  .product-inputs-container .table-controls .btn {
    width: 100%;
  }
}
@media (max-width: 576px) {
  .product-inputs-container .product-inputs-container {
    padding: 0.5rem;
  }
  .product-inputs-container .btn {
    padding: 0.5rem 1rem;
    font-size: 0.75rem;
  }
  .product-inputs-container .form-control,
  .product-inputs-container .form-select {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }
}
.product-inputs-container .loading-overlay {
  position: relative;
}
.product-inputs-container .loading-overlay::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1000;
  border-radius: inherit;
}
.product-inputs-container .loading-overlay .spinner-border {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
}
.product-inputs-container .weave-summary-row .weave-summary-col .form-label {
  width: 100%;
  text-align: center;
  font-size: 0.95rem;
}
.product-inputs-container .weave-summary-row .weave-summary-col .form-control {
  text-align: center;
  font-size: 1rem;
  min-height: 3rem;
  font-weight: 500;
}
.product-inputs-container .fade-in {
  animation: fadeIn 0.3s ease-in;
}
.product-inputs-container .slide-up {
  animation: slideUp 0.4s ease-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ProductInputs/ProductInputs.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEd;EACE,6DAAA;EACA,YAAA;EACA,oCAAA;EACA,oBAAA;AAAJ;AACI;EACE,gBAAA;EACA,iBAAA;EACA,qBAAA;AACN;AAEM;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;AAAR;AACQ;EACE,2BAAA;EACA,yCAAA;AACV;AACQ;EACE,sCAAA;EACA,YAAA;AACV;AAAU;EACE,0CAAA;EACA,mBAAA;AAEZ;AACQ;EACE,sCAAA;EACA,YAAA;AACV;AAAU;EACE,wCAAA;EACA,qBAAA;AAEZ;AAME;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AAJJ;AAKI;EACE,WAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;EACA,yBAAA;AAHN;AAME;;EAEE,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;AAJJ;AAKI;;EACE,qBAAA;EACA,8CAAA;EACA,2BAAA;AAFN;AAII;;EACE,cAAA;EACA,kBAAA;AADN;AAGI;;EACE,qBAAA;AAAN;AACM;;EACE,qBAAA;EACA,4CAAA;AAER;AAEE;EAME,qBAAA;EACA,0BAAA;AALJ;AADI;EAEE,wBAAA;EACA,SAAA;AAEN;AAIE;EACE,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAFJ;AAGI;EACE,6DAAA;EACA,YAAA;AADN;AAEM;EACE,6DAAA;EACA,2BAAA;EACA,+CAAA;AAAR;AAEM;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AAAR;AAIM;EACE,yBAAA;EACA,cAAA;AAFR;AAGQ;EACE,yBAAA;EACA,2BAAA;EACA,+CAAA;AADV;AAOE;EACE,qBAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;AALJ;AAMI;EACE,6DAAA;EACA,cAAA;EACA,8BAAA;AAJN;AAMI;EACE,6DAAA;EACA,cAAA;EACA,8BAAA;AAJN;AAQE;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AANJ;AAOI;EACE,aAAA;EACA,qBAAA;AALN;AASE;EACE,YAAA;EACA,sBAAA;EACA,0CAAA;EACA,gBAAA;AAPJ;AAQI;EACE,mBAAA;AANN;AAOM;EACE,SAAA;EACA,gBAAA;AALR;AASM;EACE,qBAAA;AAPR;AAYE;EACE;IACE,sBAAA;IACA,WAAA;EAVJ;EAWI;IACE,WAAA;EATN;AACF;AAYE;EACE;IACE,eAAA;EAVJ;EAYE;IACE,oBAAA;IACA,kBAAA;EAVJ;EAYE;;IAEE,uBAAA;IACA,iBAAA;EAVJ;AACF;AAaE;EACE,kBAAA;AAXJ;AAYI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;AAVN;AAYI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;AAVN;AAgBM;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;AAdR;AAiBM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAfR;AAqBE;EACE,8BAAA;AAnBJ;AAqBE;EACE,gCAAA;AAnBJ;AAqBE;EACE;IAAO,UAAA;EAlBT;EAmBE;IAAK,UAAA;EAhBP;AACF;AAiBE;EACE;IACE,UAAA;IACA,2BAAA;EAfJ;EAiBE;IACE,UAAA;IACA,wBAAA;EAfJ;AACF","sourcesContent":[".product-inputs-container {\n  // Tablo başlığı (eğer OrderInputs'ta tablo varsa kullanılabilir, yoksa bu kısmı atlayabilirsiniz)\n  .product-table-header {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border-radius: 0.375rem 0.375rem 0 0;\n    padding: 1rem 1.5rem;\n    h5 {\n      font-weight: 600;\n      font-size: 1.1rem;\n      letter-spacing: 0.5px;\n    }\n    .table-controls {\n      .btn {\n        transition: all 0.2s ease;\n        border-width: 2px;\n        font-weight: 500;\n        &:hover {\n          transform: translateY(-1px);\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n        }\n        &.btn-outline-success {\n          border-color: rgba(255, 255, 255, 0.6);\n          color: white;\n          &:hover {\n            background-color: rgba(255, 255, 255, 0.1);\n            border-color: white;\n          }\n        }\n        &.btn-outline-danger {\n          border-color: rgba(255, 255, 255, 0.6);\n          color: white;\n          &:hover {\n            background-color: rgba(220, 53, 69, 0.8);\n            border-color: #dc3545;\n          }\n        }\n      }\n    }\n  }\n\n  // Form ve input stilleri\n  .form-label {\n    font-weight: 600;\n    color: #495057;\n    margin-bottom: 0.5rem;\n    font-size: 0.875rem;\n    &::after {\n      content: '';\n      display: inline-block;\n      width: 0;\n      height: 0;\n      margin-left: 0.5rem;\n      border-left: 3px solid transparent;\n      border-right: 3px solid transparent;\n      border-bottom: 3px solid #667eea;\n      transition: all 0.2s ease;\n    }\n  }\n  .form-control,\n  .form-select {\n    border: 2px solid #e9ecef;\n    border-radius: 0.5rem;\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n    transition: all 0.3s ease;\n    &:focus {\n      border-color: #667eea;\n      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n      transform: translateY(-1px);\n    }\n    &::placeholder {\n      color: #adb5bd;\n      font-style: italic;\n    }\n    &.is-invalid {\n      border-color: #dc3545;\n      &:focus {\n        border-color: #dc3545;\n        box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\n      }\n    }\n  }\n  .form-control[type=\"number\"] {\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n    appearance: textfield;\n    -moz-appearance: textfield;\n  }\n  // Button styling\n  .btn {\n    border-radius: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    font-weight: 600;\n    font-size: 0.875rem;\n    transition: all 0.3s ease;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    &.btn-primary {\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      border: none;\n      &:hover {\n        background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);\n      }\n      &:disabled {\n        background: #adb5bd;\n        transform: none;\n        box-shadow: none;\n      }\n    }\n    &.btn-secondary {\n      &.btn-outline {\n        border: 2px solid #6c757d;\n        color: #6c757d;\n        &:hover {\n          background-color: #6c757d;\n          transform: translateY(-2px);\n          box-shadow: 0 8px 25px rgba(108, 117, 125, 0.2);\n        }\n      }\n    }\n  }\n  // Alert styling\n  .alert {\n    border-radius: 0.5rem;\n    border: none;\n    padding: 1rem 1.5rem;\n    margin-bottom: 1.5rem;\n    &.alert-success {\n      background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);\n      color: #155724;\n      border-left: 4px solid #28a745;\n    }\n    &.alert-danger {\n      background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);\n      color: #721c24;\n      border-left: 4px solid #dc3545;\n    }\n  }\n  // Invalid feedback styling\n  .invalid-feedback {\n    display: block !important;\n    font-size: 0.75rem;\n    color: #dc3545;\n    margin-top: 0.25rem;\n    font-weight: 500;\n    &::before {\n      content: '⚠ ';\n      margin-right: 0.25rem;\n    }\n  }\n  // Card styling (OrderInputs'ta kart kullanıyorsanız)\n  .card {\n    border: none;\n    border-radius: 0.75rem;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    overflow: hidden;\n    .card-header {\n      border-bottom: none;\n      &.product-table-header {\n        margin: 0;\n        border-radius: 0;\n      }\n    }\n    .card-body {\n      &.p-0 {\n        padding: 0 !important;\n      }\n    }\n  }\n  // Responsive adjustments\n  @media (max-width: 768px) {\n    .table-controls {\n      flex-direction: column;\n      gap: 0.5rem;\n      .btn {\n        width: 100%;\n      }\n    }\n  }\n  @media (max-width: 576px) {\n    .product-inputs-container {\n      padding: 0.5rem;\n    }\n    .btn {\n      padding: 0.5rem 1rem;\n      font-size: 0.75rem;\n    }\n    .form-control,\n    .form-select {\n      padding: 0.5rem 0.75rem;\n      font-size: 0.8rem;\n    }\n  }\n  // Loading state (OrderInputs'ta loading overlay kullanıyorsanız)\n  .loading-overlay {\n    position: relative;\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: rgba(255, 255, 255, 0.8);\n      z-index: 1000;\n      border-radius: inherit;\n    }\n    .spinner-border {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      z-index: 1001;\n    }\n  }\n\n  .weave-summary-row {\n    .weave-summary-col {\n      .form-label {\n        width: 100%;\n        text-align: center;\n        font-size: 0.95rem;\n      }\n\n      .form-control {\n        text-align: center;\n        font-size: 1rem;\n        min-height: 3rem;\n        font-weight: 500;\n      }\n    }\n  }\n\n  // Animation classes\n  .fade-in {\n    animation: fadeIn 0.3s ease-in;\n  }\n  .slide-up {\n    animation: slideUp 0.4s ease-out;\n  }\n  @keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n  }\n  @keyframes slideUp {\n    from {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
